export default "__VITE_ASSET__CV7G$Bzx__"